/* eslint-disable */
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    getPaymentHistoryDetails: {},
    getSubscriptionPlanList: {},
    getSubscriptionPlanDetails: {},
    updateSubscriptionPlanDetailsById: {},
    paidUserData:{}
  },
  mutations: {
    getPaymentHistoryFun(state, value) {
      state.getPaymentHistoryDetails = value
    },
    SubscriptionPlanListMutation(state, value) {
      state.getSubscriptionPlanList = value
    },
    SubscriptionPlanDetailsByIdMutation(state, value) {
      state.getSubscriptionPlanDetails = value
    },
    updateSubscriptionPlanDetailsMutation(state, value) {
      state.updateSubscriptionPlanDetailsById = value
    },
    getPaidFilterMut(state,value){
      state.paidUserData = value
    }
  },
  actions: {
    getPaymnetHistories(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/payment/admin/subscription/orders/').then(res => {
          context.commit('getPaymentHistoryFun', res.data);
          resolve(res);
          // debugger
        }).catch(err => {
          reject(err);
        })
      })
    },
    getSubscriptionPlanList(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/payment/admin/subscription-plan/').then(res => {
          context.commit('SubscriptionPlanListMutation', res.data);
          resolve(res);
          // debugger
        }).catch(err => {
          reject(err);
        })
      })
    },
    getSubscriptionPlanDetailsById(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/payment/admin/subscription-plan/' + payload.id + '/').then(res => {
          context.commit('SubscriptionPlanDetailsByIdMutation', res.data);
          resolve(res);
          // debugger
        }).catch(err => {
          reject(err);
        })
      })
    },
    updateSubscriptionPlanDetailsById(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/payment/admin/subscription-plan/' + payload.data.id + '/', payload.data.data).then(res => {
          context.commit('updateSubscriptionPlanDetailsMutation', res.data);
          resolve(res);
          // debugger
        }).catch(err => {
          reject(err);
        })
      })
    },
    paymentPaidFilterFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/payment/admin/subscription/orders/?is_paid=' + payload.id).then(res => {
          context.commit('getPaidFilterMut', res.data);
          resolve(res);
          // debugger
        }).catch(err => {
          reject(err);
        })
      })
    }
  },
  getters: {
    getPaymentHistoryDetailsState: state => state.getPaymentHistoryDetails,
    getSubscriptionPlanListState: state => state.getSubscriptionPlanList,
    getSubscriptionPlanDetailsState: state => state.getSubscriptionPlanDetails,
    updateSubscriptionPlanDetailsByIdState: state => state.updateSubscriptionPlanDetailsById,
    paidUserDataSatate: state => state.paidUserData
  }
}